module.exports = {
  annualReferralSlabOptions: [
    "-None-",
    "Upto 10",
    "11 to 20",
    "21 to 35",
    "36 to 50",
    "More than 50",
  ],
  referralLevelOptions: ["-None-", "A+", "A", "B", "C", "D"],
  productCategoryOptions: [
    "-None-",
    "Life",
    "Living Benefits",
    "Travel",
    "Health & Dental",
  ],
  referralPayoutOptions: [
    "-None-",
    "$100",
    "$125",
    "$150",
    "$175",
    "$200",
    "$225",
    "$250",
    "$275",
    "$300",
    "$350",
    "$375",
    "$400",
    "$425",
    "$450",
    "$525",
    "$575",
    "$675",
    "$700",
  ]
};
